import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-brand-dark pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-61">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-62">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-brand-accent opacity-20 blur-3xl" data-id="element-63"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 rounded-full bg-blue-400 opacity-10 blur-3xl" data-id="element-64"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-65">
        <div className="text-center max-w-4xl mx-auto" data-id="element-66">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-67">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6" data-id="element-68">
              Kein Anruf geht mehr verloren.
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-69">
            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-70">
              vox space ist Ihr KI-Telefonassistent — nimmt Anrufe entgegen,
              fasst sie zusammen und protokolliert alles automatisch. 24/7,
              DSGVO-konform, sofort einsatzbereit.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col items-center" data-id="element-71">
            <a href="tel:+49304397920857" className="bg-brand-accent hover:bg-blue-600 text-white text-lg font-semibold px-8 py-4 rounded-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-blue-500/30 w-full sm:w-auto text-center" data-id="element-72">
              Jetzt live testen
            </a>
            <p className="mt-4 text-sm text-gray-400" data-id="element-73">
              Keine Vertragsbindung. Monatlich kündbar.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}